import { OnlineBookingAddonListStep } from 'components/OnlineBooking/AddonList/OnlineBookingAddonListStep';
import React from 'react';
import { MarketplaceServiceCategory } from 'types/Marketplace';

export const OnlineBookingBoardingAddonListStep: React.FC = () => (
    <OnlineBookingAddonListStep category={MarketplaceServiceCategory.BOARDING} />
);
